// Step 5d Phase 4 — in-memory DEK session.
//
// The unwrapped DEK lives ONLY here, in memory, after a successful PIN unlock. It is NEVER
// persisted unwrapped (only its PIN-wrapped copies sit in the profiles store). Cleared on
// lock, 7-day expiry, logout, and revocation-purge. While null, the encryption layer
// cannot read/write the protected stores → the unlock gate stands in front of the cache.

let dekRaw: Uint8Array | null = null;
let unlockedUserId: string | null = null;

type Listener = () => void;
const listeners = new Set<Listener>();
const notify = () => { for (const l of listeners) l(); };

export function subscribeDek(l: Listener): () => void {
  listeners.add(l);
  return () => { listeners.delete(l); };
}

export function setUnlockedDek(raw: Uint8Array, userId: string): void {
  dekRaw = raw;
  unlockedUserId = userId;
  notify();
}

/** The unwrapped DEK, or null when locked. Callers in the encryption layer require non-null. */
export const getDek = (): Uint8Array | null => dekRaw;
export const isUnlocked = (): boolean => dekRaw !== null;
export const unlockedProfileUserId = (): string | null => unlockedUserId;

/** Wipe the DEK from memory (lock / expiry / logout / purge). Zero the bytes first. */
export function clearDek(): void {
  if (dekRaw) dekRaw.fill(0);
  dekRaw = null;
  unlockedUserId = null;
  notify();
}
